<template>
  <div class="tw-mb-4">
    <cl-heading :size="'h5'">{{ $t("bypass-checks") }}</cl-heading>
    <cl-p size="sm">
      {{ $t("select-checks-for-exemption") }}
    </cl-p>
    <div class="tw-flex tw-flex-col tw-gap-4">
      <exemptions-bypass-checks-group
        type="authentication"
        :checkboxes="authenticationCheckboxes"
        @update:checkbox="updateCheckbox"
        @update:all="(value) => updateAll('authentication', value)"
      />
      <exemptions-bypass-checks-group
        type="suspicious"
        :checkboxes="suspiciousCheckboxes"
        @update:checkbox="updateCheckbox"
        @update:all="(value) => updateAll('suspicious', value)"
      />
      <exemptions-bypass-checks-group
        type="malicious"
        :checkboxes="maliciousCheckboxes"
        @update:checkbox="updateCheckbox"
        @update:all="(value) => updateAll('malicious', value)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import ExemptionsBypassChecksGroup from "./exemptions-bypass-checks-group.vue";
import { BypassCheck } from "../exemptions.types";

type BypassCheckbox = {
  key: BypassCheck;
  label: string;
  checked: boolean;
};

const bypassChecks = defineModel<Record<BypassCheck, boolean>>("bypassChecks", {
  required: true,
});

const authenticationCheckboxes = computed<BypassCheckbox[]>(() => [
  {
    key: "antispoof",
    label: "anti-spoof-tab",
    checked: bypassChecks.value.antispoof,
  },
]);
const suspiciousCheckboxes = computed<BypassCheckbox[]>(() => [
  { key: "spam", label: "spam-legend", checked: bypassChecks.value.spam },
  {
    key: "frequently_exploited_domains",
    label: "frequently-exploited-domains-tab",
    checked: bypassChecks.value.frequently_exploited_domains,
  },
  {
    key: "graymail",
    label: "graymail-tab",
    checked: bypassChecks.value.graymail,
  },
  {
    key: "suspicious_intent",
    label: "suspicious-intent-checkbox",
    checked: bypassChecks.value.suspicious_intent,
  },
]);

const maliciousCheckboxes = computed<BypassCheckbox[]>(() => [
  { key: "fraud", label: "fraud-legend", checked: bypassChecks.value.fraud },
  {
    key: "malware",
    label: "malware-legend",
    checked: bypassChecks.value.malware,
  },
  {
    key: "malicious_intent",
    label: "malicious",
    checked: bypassChecks.value.malicious_intent,
  },
  {
    key: "phishing",
    label: "phishing-legend",
    checked: bypassChecks.value.phishing,
  },
]);

const updateCheckbox = (key: string, value: boolean) => {
  bypassChecks.value[key as BypassCheck] = value;
};

const updateAll = (type: string, value: boolean) => {
  const checkboxMap = {
    authentication: authenticationCheckboxes.value,
    suspicious: suspiciousCheckboxes.value,
    malicious: maliciousCheckboxes.value,
  };
  checkboxMap[type as keyof typeof checkboxMap].forEach((checkbox) => {
    bypassChecks.value[checkbox.key] = value;
  });
};
</script>
